import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Box } from '@tonic-ui/react';

import { getMaintenanceModeState } from './../store';
import { useTranslation, Trans } from 'react-i18next';
import NotificationBanner from './notification-banner/notification-banner';
import ExternalLink from './external-link/external-link';

export const MaintenanceNoticeBanner = (): JSX.Element | null => {
  const { i18n } = useTranslation();

  const { enabled: isMaintenanceModeEnabled, bannerMessage } = useSelector(
    (state) => getMaintenanceModeState(state, i18n.language ?? 'en'),
    shallowEqual
  ) as { enabled: boolean; bannerMessage: string };

  if (isMaintenanceModeEnabled !== true) {
    return null;
  }

  // Extract the URL from the bannerMessage
  const url = bannerMessage.match(/<docLink>(.*?)<\/docLink>/)?.[1] ?? '';

  return (
    <NotificationBanner
      name="maintenance-notice"
      severity="warning"
      showCloseButton={false}
      shouldOpen={true}
      htmlElement={
        <Box as="p" m="0" display="inline-block">
          <Trans
            components={{
              docLink: <ExternalLink showIcon={false} href={url} />,
            }}
          >
            {bannerMessage}
          </Trans>
        </Box>
      }
    />
  );
};

MaintenanceNoticeBanner.displayName = 'MaintenanceNoticeBanner';
